import type { HTMLAttributes } from 'react';

import { cx } from '../../lib/cx';

import styles from './Card.module.css';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** surface: the usual white card; sunken: a quieter block inside one; inverse: the dark accent. */
  tone?: 'surface' | 'sunken' | 'inverse';
  /** md: forms and small blocks; lg: content cards. */
  radius?: 'md' | 'lg';
  /** stack: children in a column with even gaps; plain: a block whose content spaces itself. */
  layout?: 'stack' | 'plain';
}

/** The surface other things sit on. Padding follows the device. */
export function Card({ tone = 'surface', radius = 'lg', layout = 'stack', className, ...rest }: CardProps) {
  return <div className={cx(styles.card, layout === 'stack' && styles.stack, styles[tone], styles[radius], className)} data-tone={tone} {...rest} />;
}
